export const INT_CALLING_TERMS_AND_CONDITIONS_ROUTE_URLS = {
    INT_CALLING_TERMS_OF_USE: 'terms-of-use',
    INT_CALLING_PRIVACY_POLICY: 'privacy-policy',
    INT_CALLING_EULA: 'eula',
  };
